import { Component, ChangeDetectorRef, NgZone, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Overlay } from '@angular/cdk/overlay';

import { DistributionList } from '../users/distribution-list.model';
import { DistributionListsDialogComponent } from '../users/distribution-lists-dialog.component';
import { TokenItem } from './tokens-field.component';
import { User } from '../users/user.model';
import { UsersService } from '../users/users.service';
import { UsersFieldComponent } from './users-field.component';

@Component({
  selector: 'app-users-and-lists-field',
  templateUrl: './autocomplete-tokens-field.component.html',
  styleUrls: ['./autocomplete-tokens-field.component.scss']
})
export class UsersAndListsFieldComponent extends UsersFieldComponent {

  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    usersService: UsersService,
    private dialog: MatDialog,
    private ngZone: NgZone) { super(cd, overlay, usersService) }

  @Output() listAdded = new EventEmitter<number>();
  @Input() distributionLists: DistributionList[] = [];

  hasInputDialog: boolean = true;

  showInputDialog() {
    let dialogRef = this.dialog.open(DistributionListsDialogComponent, {
      height: Math.min(window.innerHeight, 582)+"px",
      width: Math.min(window.innerWidth, 600)+"px",
      data: {workflowId: this.workflowId}
    });
    dialogRef.afterClosed().subscribe((list) => {
      if (list != null) {
        this.addList(list);
      }
    })
  }

  addList(list: DistributionList) {
    let item = new TokenItem();
    item.value = {
      stored: list,
      displayed: list.name
    };
    item.valid = true;
    item.icon = "menu";
    item.toolTip = list.userNames;
    this.addItem(item);
    this.listAdded.emit(list.id);
  }

  loadItems(values?: any[]): TokenItem[] {
    let items = super.loadItems(values);
    for (let item of items) {
      let stored = item.value.stored;
      if (stored != null && stored.users != null) {
        let list = new DistributionList(stored);
        let existing = this.distributionLists.find((l) => { return list.id === l.id; });
        if (existing != null) { list = existing; };
        stored.users = list.users
        item.icon = "menu";
        item.toolTip = list.userNames;
        this.listAdded.emit(stored.id);
      }
    }
    return items;
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/users-and-lists-field.component.ts